import React, { useEffect } from "react";
import "assets/scss/partials/microsoftTeams.scss";
import * as microsoftTeams from "@microsoft/teams-js";
import { useGlobalContext } from "store/contexts/globalContext";
import { useHistory } from "react-router-dom";

export default () => {
  const { microsoftConfigureTab } = useGlobalContext();
  const history = useHistory();

  useEffect(() => {
    if (!microsoftConfigureTab) {
      history.replace("/");
    }

    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    //eslint-disable-next-line
  }, [history, microsoftConfigureTab]);

  return (
    <>
      <div className="msRoot">
        <div className="unAuthorizedRoot">
          <div className="content">
            You are not authorized to access this team
          </div>
        </div>
      </div>
    </>
  );
};
